import React from 'react';
import { Heading, Text } from 'prospect-path-components';

const NotFound = props => (
  <div className="l-wrapper-container">
    <div className="l-wrapper-content">
      <Heading>Not Found</Heading>
      <Text>The page you are looking for could not be found.</Text>
    </div>
  </div>
);

export default NotFound;
